import { Amount } from '@/services/settlement/settlementManagement/types'
import { VStack } from '@musinsa/mwms-ds'
import Text from '@/components/content/Text'
import { Utils } from '@/utils/Utils'
import { colorSystem } from '@/styles/theme'
import { CSSProperties } from 'react'
import { isNil } from 'lodash-es'

export const AmountCell = ({ originAmount, discountedAmount, align = 'end' }: { align?: CSSProperties['alignItems'] } & Partial<Amount>) => (
  <VStack
    style={{
      alignItems: align,
    }}
  >
    <Text kind="Body_12_regular">{!isNil(discountedAmount) ? `${Utils.getCommaNum(discountedAmount)}원` : '-'}</Text>
    {Boolean(originAmount) && originAmount !== discountedAmount && (
      <Text kind="Body_12_regular" color={colorSystem.text.common.tertiary} style={{ textDecoration: 'line-through' }}>
        {Utils.getCommaNum(originAmount)}원
      </Text>
    )}
  </VStack>
)
